<template>
  <div>
    <v-tabs v-model="selectedTab">
      <v-tab>Settings</v-tab>
      <v-tab v-for="(item, index) in items" :key="'item-' + index">Item {{ index + 1 }}</v-tab>
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon tile @click="addItem">
            <v-icon>fal fa-plus</v-icon>
          </v-btn>
        </template>
        <span>Add Item to Popup Set</span>
      </v-tooltip>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item>
        <v-card style="min-height:557px">
          <v-card-text>
            <v-text-field v-model="name" label="Name of block (for administrative purposes; optional)" hide-details></v-text-field>
            <v-checkbox v-model="activatable" label="Each item can be activated/inactivated" hide-details></v-checkbox>
            <v-checkbox v-model="mustComplete" :label="activatable ? 'Make it required: Student must activate or deactivate all options to proceed' : 'Make it required: Student must view all popups to proceed'"></v-checkbox>
            <!-- <html-editor v-model="content"></html-editor> -->
          </v-card-text>
        </v-card>
      </v-tab-item>
      <popups-item v-for="(item, index) in items" :key="'item-content-' + index" :activatable="activatable" :item="item" @update="(val) => update(val, index)" @removeItem="removeItem(index)"></popups-item>
    </v-tabs-items>
  </div>
</template>
<style scoped>
div.image-card-overlay {
  padding: .5em;
  text-align: center;
}
div.image-card-overlay.dark {
  background-color: rgba(0,0,0,.8);
  color: white;
}
div.image-card-overlay.light {
  background-color: rgba(255,255,255,.8);
  color: black;
}
div.carousel-overlay-text {
  padding: .7em;
}
div.carousel-overlay-text :last-child {
  margin-bottom: 0
}
</style>
<script>
import { ref, watch } from '@vue/composition-api'
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    // HtmlEditor: () => import('@/components/forms/HTMLEditor'),
    PopupsItem: () => import('@/components/admin/editor/popups/item')
  },
  setup (props, { root, emit }) {
    const selectedTab = ref(0)
    const name = ref(props.value.name || '')
    const activatable = ref('activatable' in props.value ? props.value.activatable : false)
    const mustComplete = ref('mustComplete' in props.value ? props.value.mustComplete : false)
    const content = ref(props.value.content || '')
    const items = ref([])

    watch(() => props.value, () => {
      name.value = props.value.name || ''
      activatable.value = 'activatable' in props.value ? props.value.activatable : false
      mustComplete.value = 'mustComplete' in props.value ? props.value.mustComplete : false
      content.value = props.value.content || ''
      items.value = props.value.items || []
    })

    watch(name, () => name.value !== props.value.name ? emit('update', { name: name.value }) : '')
    watch(activatable, () => activatable.value !== props.value.activatable ? emit('update', { activatable: activatable.value }) : '')
    watch(mustComplete, () => mustComplete.value !== props.value.mustComplete ? emit('update', { mustComplete: mustComplete.value }) : '')
    watch(content, () => content.value !== props.value.content ? emit('update', { content: content.value }) : '')
    watch(items, () => items.value !== props.value.items ? emit('update', { items: items.value }) : '')

    function addItem () {
      items.value.push({
        title: '',
        text: '',
        activate: '',
        deactivate: '',
        email: '',
        link: ''
      })
      setTimeout(() => { selectedTab.value = items.value.length }, 100)
    }
    function removeItem (index) {
      if (confirm('Are you sure you want to remove this item from the popup set?')) {
        items.value.splice(index, 1)
      }
    }

    function validate () {
      // Ensure that each item has a title and text (and the text is not just <p></p>)
      for (let i = 0; i < items.value.length; i++) {
        if (items.value[i].title == null || items.value[i].title === '') {
          alert('Each item must have text for the activator button')
          return false
        } else if (items.value[i].text == null || items.value[i].text === '' || items.value[i].text === '<p></p>') {
          alert('Each item must have text for the popup window')
          return false
        }
      }
      return true
    }

    function update (val, index) {
      let temp = items.value.splice(index, 1)[0]
      for (let l in val) {
        temp[l] = val[l]
      }
      items.value.splice(index, 0, temp)
    }

    return {
      selectedTab,
      name,
      activatable,
      mustComplete,
      content,
      items,
      addItem,
      removeItem,
      validate,
      update
    }
  }
}
</script>
